/* eslint-disable prettier/prettier */
/* eslint-disable no-empty */
import {
  LOGIN_SUCCESS,
  UPDATE_SCREEN_NAME,
  LOGOUT_SUCCESS,
  SIGN_UP_SUCCESS,
  UPDATE_USER_INFO,
  UPDATE_USER_PASSWORD,
  UPDATE_ADDRESS_INFO,
  UPDATE_BANK_DETAILS,
  UPDATE_EMAIL_DETAILS,
  UPDATE_PAN_DETAILS,
  UPDATE_PHONE_DETAILS,
  ADDRESS_STATUS,
  UPDATE_GAME_TYPE,
  UPDATE_SUBSCRIBED_MATCH_LIST,
  SET_USER_NAME,
  SET_EMAIL_VERIFY_COUNT_DATA,
  UPDATE_USER_DATA,
  SET_WALLET_BALLANCE,
  SET_AVATAR,
  SET_OPPONENT_USER,
  UPDATE_USER_LEVEL,
  SET_ISLOGIN,
  SET_ISSIGNUP,
  SIGNIN_WITH_MOBILE,
  SET__USER__LOGIN__MODAL,
  USER_LOGOUT,
  RESET_SIGNIN_MODES,
  SET_IS_SPIN_THE_WHEEL,
  SET_IS_DRAWER_OPEN
} from '../actions/user-actions-types';
import { UPDATE_BALANCE } from '../actions/account-actions-types';
import { getIdFromLink } from '../utilities/helper';

const initialState = {
  userId: '639875b3ae6c46001be9c56a',
  screenName: '',
  loginType: '',
  verified: false,
  gameType: '',
  affiliateId: '',
  affiliateLink: '',
  referralLink: '',
  referralId: '',
  referAffiliateId: '', //this id for my referral affiliate
  password: '',
  teamName: '',
  lockTeamName: true,
  token:
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJwYXlsb2FkIjp7ImlkIjoiNjM5ODc1YjNhZTZjNDYwMDFiZTljNTZhIiwidGVuYW50IjoiZGV2IiwiX2lkIjoiNjM5ODc1YjNhZTZjNDYwMDFiZTljNTZhIiwidXNlcm5hbWUiOiI2Mzk4NzViM2FlNmM0NjAwMWJlOWM1NjkiLCJzY29wZXMiOlsiYXV0aCJdfSwiaWF0IjoxNjcyMjI0MDkwLCJleHAiOjE3NTg2MjQwOTAsImF1ZCI6WyIqIl0sImlzcyI6ImRldiIsInN1YiI6IjYzOTg3NWIzYWU2YzQ2MDAxYmU5YzU2YSIsImp0aSI6IjYzYWMxZDVhYWU2YzQ2MDAxYmU5ZDAxNiJ9._X4v9jpQc3S_bCygUWheDAXGKyx7c5DfFFq4NPjHUkE',
  firstName: '',
  lastName: '',
  gender: '',
  dob: 0,
  emails: [],
  phones: [],
  pan: {},
  bankAccounts: [],
  balanceInfo: {},
  addressInfo: [],
  addressStatus: false, //this field use for track address status whether user submit or not yet
  statuses: {
    bankAccounts: 'not_set',
    pan: 'not_set',
    emails: 'not_set',
    phones: 'not_set',
    addresses: 'not_set'
  },
  subscribedMatchList: [], //this contains matchId and timestamp,
  emailVerifyAPICount: {
    time: 0,
    count: 0
  },
  createdOn: '',
  opponentUser: {},
  avatarId: 0,
  isSpinTheWheelPlayed: false,
  xpPoints: 10,
  userLevel: 0,
  isLogin: true,
  isSignUp: false,
  isMobileLogin: false,
  isLoginModal: false,
  isSpinTheWheelOpen: false,
  isDrawerOpen: false
};

export default function user(
  state = initialState,
  action: {
    type: any;
    payload: any;
  }
) {
  switch (action.type) {
    case LOGIN_SUCCESS: {
      const { userId, loginType, token } = action.payload;
      return {
        ...state,
        userId,
        loginType,
        screenName: true,
        token
      };
    }
    case SET_WALLET_BALLANCE: {
      return {
        ...state,
        balanceInfo: {
          bonusWallet: action.payload.bonusWallet,
          gameWallet: action.payload.gameWallet,
          primaryWallet: action.payload.primaryWallet,
          pokerWallet: action.payload.pokerWallet,
          cashbackWallet: action.payload.cashbackWallet
        }
      };
    }

    case SIGN_UP_SUCCESS: {
      const { userId, loginType, token } = action.payload;
      return {
        ...state,
        userId,
        loginType,
        screenName: false,
        token: token
      };
    }

    case UPDATE_SCREEN_NAME:
      return { ...state, screenName: action.payload };

    case UPDATE_USER_INFO: {
      const {
        username: teamName = '',
        firstname: firstName = '',
        lastname: lastName = '',
        createdOn = '',
        gender = '',
        dob = '',
        referralLink = '',
        affiliate: affiliateData = [],
        affiliateId: referAffiliateId = '',
        lockUsername: lockTeamName = false
      } = action.payload;
      let affiliateLink = '',
        affiliateId = '',
        referralId = '';
      if (affiliateData && affiliateData.length > 0) {
        affiliateLink = affiliateData[0].link;
        affiliateId = getIdFromLink(affiliateLink);
      } else {
        try {
          referralId = getIdFromLink(referralLink);
        } catch (error) {}
      }
      return {
        ...state,
        teamName,
        gender,
        dob,
        firstName,
        lastName,
        referralId,
        referralLink,
        affiliateId,
        affiliateLink,
        referAffiliateId,
        lockTeamName,
        createdOn
      };
    }

    case LOGOUT_SUCCESS: {
      const { addressInfo, addressStatus } = state;
      const { id = '' } = addressInfo ? (addressInfo[0] ? addressInfo[0] : {}) : {};
      const initialStateTemp = { ...initialState };
      initialStateTemp.statuses = { ...initialState.statuses };
      if (id) {
        return initialStateTemp;
      }
      return { ...initialStateTemp, addressInfo, addressStatus };
    }
    case UPDATE_BALANCE:
      return { ...state, balanceInfo: action.payload };

    case UPDATE_USER_PASSWORD:
      return { ...state, password: action.payload };

    case UPDATE_BANK_DETAILS: {
      const { statuses = { ...initialState.statuses } } = state;
      statuses.bankAccounts = 'set';
      let bankAccounts = action.payload;
      if (bankAccounts.length > 0) {
        statuses.bankAccounts = bankAccounts[0].status;
      }
      return { ...state, bankAccounts: action.payload, statuses };
    }
    case UPDATE_EMAIL_DETAILS: {
      const { statuses = { ...initialState.statuses } } = state;
      statuses.emails = 'set';
      let emails = action.payload;
      if (emails.length > 0) {
        statuses.emails = emails[0].verified ? 'verified' : 'set';
      }
      return { ...state, emails: action.payload, statuses };
    }
    case UPDATE_PAN_DETAILS: {
      // here from initialState, statuses is set, because there may be phones in which previously this ley doesn't exist
      const { statuses = { ...initialState.statuses } } = state;
      statuses.pan = 'set';
      let pan = action.payload;
      if (pan && pan.status) {
        statuses.pan = pan.status;
      }
      return { ...state, pan: action.payload, statuses };
    }
    case UPDATE_PHONE_DETAILS: {
      const { statuses = { ...initialState.statuses } } = state;
      statuses.phones = 'set';
      let phones = action.payload;
      if (phones.length > 0) {
        statuses.phones = phones[0].verified ? 'verified' : 'set';
      }
      return { ...state, phones: action.payload, statuses };
    }
    case UPDATE_ADDRESS_INFO: {
      const { statuses = { ...initialState.statuses }, addressInfo } = state;
      statuses.addresses = 'set';
      let data = action.payload;
      if (data && data.length > 0) {
        const { street = '' } = data[0];
        if (street && street.length > 0) {
          statuses.addresses = 'verified';
        }
      } else if (data && data.length === 0) {
        data = addressInfo;
      }

      return { ...state, addressInfo: data, statuses };
    }
    case ADDRESS_STATUS:
      return { ...state, addressStatus: true };
    case UPDATE_GAME_TYPE: {
      return {
        ...state,
        gameType: action.payload
      };
    }

    case UPDATE_SUBSCRIBED_MATCH_LIST: {
      return {
        ...state,
        subscribedMatchList: action.payload
      };
    }
    case SET_USER_NAME: {
      return {
        ...state,
        lockTeamName: true,
        teamName: action.payload
      };
    }
    case SET_EMAIL_VERIFY_COUNT_DATA:
      return {
        ...state,
        emailVerifyAPICount: action.payload
      };
    case UPDATE_USER_DATA: {
      const {
        firstName = '',
        lastName = '',
        gender = '',
        dob = 0,
        xpPoints = state.xpPoints
      } = action?.payload;
      return {
        ...state,
        firstName,
        lastName,
        gender,
        dob,
        xpPoints
      };
    }
    case UPDATE_USER_LEVEL:
      return {
        ...state,
        userLevel: action.payload
      };
    case SET_AVATAR: {
      return {
        ...state,
        avatarId: action.payload
      };
    }
    case SET_OPPONENT_USER:
      return {
        ...state,
        opponentUser: { ...action.payload }
      };
    case SET_ISLOGIN:
      return {
        ...state,
        isLogin: action.payload,
        isSignUp: false,
        isMobileLogin: false
      };
    case SET_ISSIGNUP:
      return {
        ...state,
        isLogin: false,
        isSignUp: action.payload,
        isMobileLogin: false
      };

    case SIGNIN_WITH_MOBILE:
      return {
        ...state,
        isLogin: false,
        isSignUp: false,
        isMobileLogin: action.payload
      };
    case SET__USER__LOGIN__MODAL:
      return {
        ...state,
        isLoginModal: action.payload
      };
    case RESET_SIGNIN_MODES:
      return {
        ...state,
        isLogin: false,
        isSignUp: false,
        isMobileLogin: false
      };
    case USER_LOGOUT:
      return {
        ...state,
        isLogin: false,
        isSignUp: false,
        isMobileLogin: false,
        teamName: ''
      };
    case SET_IS_SPIN_THE_WHEEL:
      return {
        ...state,
        isSpinTheWheelOpen: action.payload
      };

    case SET_IS_DRAWER_OPEN:
      return {
        ...state,
        isDrawerOpen: action.payload
      };

    default:
      return state;
  }
}
